import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';

import {
  AzureResourceGroupPicker,
  AzureResourcePicker,
  AzureSubscriptionPicker,
} from './fields';

export default createFrontendPlugin({
  extensions: [
    FormFieldBlueprint.make({
      name: 'azure-subscription-picker',
      params: { field: async () => AzureSubscriptionPicker },
    }),
    FormFieldBlueprint.make({
      name: 'azure-resource-group-picker',
      params: { field: async () => AzureResourceGroupPicker },
    }),
    FormFieldBlueprint.make({
      name: 'azure-resource-picker',
      params: { field: async () => AzureResourcePicker },
    }),
  ],
  pluginId: 'azure-pickers',
});
